import React, { Component } from "react";
import { fire, auth } from "../../firebase/index";
import {
  customLog,
  deploymentEnvironment,
  style,
} from "../../variables/Variables";
import { Button, Modal } from "react-bootstrap";
import "../../assets/css/maincss.css";
import NotificationSystem from "react-notification-system";
import LocalizedStrings from "react-localization";

let localizationStrings = new LocalizedStrings({
  en: {
    getInTouchTitle: "Get in touch",
    getInTouchSubTitle:
      "Want to get in touch? We'd love to hear from you. Here's how you can reach us",
    contactSaleBtn: "Contact Sales Team",
    contactTechBtn: "Contact Technical Team",
    saleTitle: "Sales Support",
    saleSubTitle:
      "Have a pricing question or need help to manage your account?",
    contactSaleTitle: "Contact Sales Support",
    technicalTitle: "Technical Support",
    technicalSubTitle:
      "Already using our products and experiencing technical issues?",
    contactTechnicalTitle: "Contact Technical Support",
    nameTitle: "Enter your name*",
    emailTitle: "Enter your email address*",
    subjectTitle: "Enter a Subject*",
    messageTitle: "Enter your Message*",
    sendMessageButton: "SEND MESSAGE",
    successMessage: "Message Sent!",
    errorMessage: "Something went wrong! Please Try again!",
  },
  ja: {
    getInTouchTitle: "お問い合わせ",
    getInTouchSubTitle:
      "ご連絡を希望されますか？ぜひお知らせください。こちらからご連絡いただけます。",
    contactSaleBtn: "営業チームに連絡",
    contactTechBtn: "技術チームに連絡",
    saleTitle: "営業サポート",
    saleSubTitle:
      "料金について質問がある場合や、アカウント管理に関して助けが必要ですか？",
    contactSaleTitle: "営業サポートに連絡",
    technicalTitle: "技術サポート",
    technicalSubTitle:
      "すでに弊社の製品を使用していて、技術的な問題に直面していますか？",
    contactTechnicalTitle: "技術サポートに連絡",
    nameTitle: "お名前を入力してください*",
    emailTitle: "メールアドレスを入力してください*",
    subjectTitle: "件名を入力してください*",
    messageTitle: "メッセージを入力してください*",
    sendMessageButton: "メッセージを送信",
    successMessage: "メッセージが送信されました！",
    errorMessage: "何かがうまくいきませんでした！再試行してください。",
  },
  es: {
    getInTouchTitle: "Póngase en contacto",
    getInTouchSubTitle:
      "¿Quieres ponerte en contacto? Nos encantaría saber de ti. Aquí te mostramos cómo puedes alcanzarnos",
    contactSaleBtn: "Contactar al Equipo de Ventas",
    contactTechBtn: "Contactar al Equipo Técnico",
    saleTitle: "Soporte de Ventas",
    saleSubTitle:
      "¿Tienes una pregunta sobre precios o necesitas ayuda para gestionar tu cuenta?",
    contactSaleTitle: "Contactar Soporte de Ventas",
    technicalTitle: "Soporte Técnico",
    technicalSubTitle:
      "¿Ya estás utilizando nuestros productos y experimentando problemas técnicos?",
    contactTechnicalTitle: "Contactar Soporte Técnico",
    nameTitle: "Ingresa tu nombre*",
    emailTitle: "Ingresa tu dirección de correo electrónico*",
    subjectTitle: "Ingresa un Asunto*",
    messageTitle: "Ingresa tu Mensaje*",
    sendMessageButton: "ENVIAR MENSAJE",
    successMessage: "¡Mensaje enviado!",
    errorMessage: "¡Algo salió mal! Por favor, intenta de nuevo.",
  },
});

class ContactUs extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userAccountDetails: {},
      showSupportPopup: false,
      showSalePopup: false,
      userLoggedIn: false,
      inputName: "",
      inputEmail: "",
      inputSubject: "",
      inputMessage: "",
      _notificationSystem: null,
      showPopup: false,
      showPopupTitle: "",
      showPopupFilter: "",
      currentLanguage: "",
    };

    this.handleNameInput = this.handleNameInput.bind(this);
    this.handleEmailInput = this.handleEmailInput.bind(this);
    this.handleSubjectInput = this.handleSubjectInput.bind(this);
    this.handleMessageInput = this.handleMessageInput.bind(this);
    this.handleSendEmail = this.handleSendEmail.bind(this);
    this.handlePopupClose = this.handlePopupClose.bind(this);
  }
  componentWillMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("registeredIndustrialUsersOnPlatform")
        .child(auth.currentUser.uid)
        .once("value")
        .then((snapshot) => {
          this.setState({
            userAccountDetails: snapshot.val(),
          });
        });

      //! FOR LANGUAGE SETTINGS
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
            userLoggedIn: true,
          });
        });
    }
  }

  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }

  showNotification(msg, lvl, dismissal, allowDismiss) {
    let dismissalAllowed = false;

    if (allowDismiss === "") {
      dismissalAllowed = true;
    }
    //var level = lvl; // 'success', 'warning', 'error' or 'info'
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-bell"></span>,
      message: <div>{msg}</div>,
      level: lvl,
      position: "tc",
      autoDismiss: dismissal,
      dismissible: dismissalAllowed,
    });

    this.setState({
      showPopup: false,
    });
  }

  handlePopupClose() {
    this.setState({
      showPopup: false,
    });
  }

  handleNameInput(input) {
    if (input.target.value !== "") {
      this.setState({
        inputName: input.target.value,
      });
    }
  }

  handleEmailInput(input) {
    if (input.target.value !== "") {
      this.setState({
        inputEmail: input.target.value,
      });
    }
  }

  handleSubjectInput(input) {
    if (input.target.value !== "") {
      this.setState({
        inputSubject: input.target.value,
      });
    }
  }

  handleMessageInput(input) {
    if (input.target.value !== "") {
      this.setState({
        inputMessage: input.target.value,
      });
    }
  }

  async handleSendEmail(e) {
    e.preventDefault();
    let DataToSend = {};
    var filterTypeSupport = "";
    var existingAccountUid = "";

    if (this.state.showPopupFilter === "sale") {
      filterTypeSupport = "The Sales Team";
    } else if (this.state.showPopupFilter === "tech") {
      filterTypeSupport = "The Technical Team";
    }

    await fire
      .database()
      .ref("registeredUsersOnPlatform")
      .once("value")
      .then((snapshot) => {
        snapshot.forEach((usersEmail) => {
          if (usersEmail.val() === this.state.inputEmail) {
            existingAccountUid = usersEmail.key;
          }
        });
      })
      .then(() => {
        if (existingAccountUid === "") {
          existingAccountUid = "No IAM Account";
        }
      });

    if (auth.currentUser !== null) {
      DataToSend = {
        deploymentEnvironment: deploymentEnvironment,
        supportType: filterTypeSupport,
        name: this.state.userAccountDetails.name,
        email: auth.currentUser.email,
        subject: this.state.inputSubject,
        message: this.state.inputMessage,
        language: this.state.currentLanguage,
        // userExist: auth.currentUser.uid
      };
    } else {
      DataToSend = {
        deploymentEnvironment: deploymentEnvironment,
        supportType: filterTypeSupport,
        name: this.state.inputName,
        email: this.state.inputEmail,
        subject: this.state.inputSubject,
        message: this.state.inputMessage,
        language: this.state.currentLanguage,
        // userExist: existingAccountUid
      };
    }

    await fetch(
      "https://us-central1-egeetouchindustrial.cloudfunctions.net/contactUs",
      {
        method: "POST",
        body: JSON.stringify(DataToSend),
      }
    )
      .then(async (response) => {
        customLog(response);
        let returnedVal = await response.json();
        customLog(returnedVal);
        await this.showNotification(
          localizationStrings.successMessage,
          "success",
          3
        );
      })
      .catch((err) => {
        customLog(err);
        this.showNotification(localizationStrings.errorMessage, "error", 3);
      });
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    //! LANGUAGE SETTING
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    return (
      <div style={{ maxWidth: "95%", margin: "auto" }} className="header">
        <NotificationSystem ref="notificationSystem" style={style} />
        <div>
          <h2>{localizationStrings.getInTouchTitle}</h2>
          <h4>{localizationStrings.getInTouchSubTitle}</h4>
        </div>
        <div className="contactContainer">
          <div style={{ margin: "30px" }}>
            <div id="saleLabel" class="fa fa-phone"></div>
            <div className="contactDetails">
              <h3>{localizationStrings.saleTitle}</h3>
              <h5>{localizationStrings.saleSubTitle}</h5>

              <button
                className="contactButton"
                onClick={async () => {
                  await this.setState({
                    showPopupFilter: "sale",
                    showPopup: true,
                    showPopupTitle: localizationStrings.contactSaleTitle,
                  });
                }}
              >
                {localizationStrings.contactSaleBtn}
              </button>
            </div>
          </div>
          <div style={{ margin: "30px" }}>
            <div id="supportLabel" class="fa fa-comments"></div>
            <div className="contactDetails">
              <h3>{localizationStrings.technicalTitle}</h3>
              <h5>{localizationStrings.technicalSubTitle}</h5>

              <button
                className="contactButton"
                onClick={async () => {
                  await this.setState({
                    showPopupFilter: "tech",
                    showPopup: true,
                    showPopupTitle: localizationStrings.contactTechnicalTitle,
                  });
                }}
              >
                {localizationStrings.contactTechBtn}
              </button>
            </div>
          </div>
        </div>
        <Modal show={this.state.showPopup} onHide={this.handlePopupClose}>
          <Modal.Header
            style={
              this.state.showPopupFilter === "sale"
                ? { backgroundColor: "#369af6", color: "white" }
                : { backgroundColor: "#003663", color: "white" }
            }
            closeButton
          >
            <Modal.Title style={{ textAlign: "center" }}>
              {this.state.showPopupTitle}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={this.handleSendEmail}>
              {this.state.userLoggedIn ? (
                <input
                  style={{ backgroundColor: "lightgrey" }}
                  className="contactInput"
                  placeholder={this.state.userAccountDetails.name}
                  disabled
                />
              ) : (
                <input
                  className="contactInput"
                  placeholder={localizationStrings.nameTitle}
                  onChange={this.handleNameInput}
                  type="text"
                  required
                />
              )}
              {this.state.userLoggedIn ? (
                <input
                  style={{ backgroundColor: "lightgrey" }}
                  className="contactInput"
                  placeholder={auth.currentUser.email}
                  disabled
                />
              ) : (
                <input
                  className="contactInput"
                  placeholder={localizationStrings.emailTitle}
                  onChange={this.handleEmailInput}
                  type="email"
                  required
                />
              )}

              <input
                className="contactInput"
                placeholder={localizationStrings.subjectTitle}
                onChange={this.handleSubjectInput}
                type="text"
                required
              />

              <textarea
                className="contactTextArea"
                placeholder={localizationStrings.messageTitle}
                onChange={this.handleMessageInput}
                required
              />

              <Button
                style={
                  this.state.showPopupFilter === "sale"
                    ? { backgroundColor: "#369af6", color: "white" }
                    : { backgroundColor: "#003663", color: "white" }
                }
                type="submit"
              >
                {localizationStrings.sendMessageButton}
              </Button>
            </form>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default ContactUs;
